module.exports = __webpack_public_path__ + "static/media/1001270TL.843a0ac2.jpg";